<!--
 * @Description: 受理进度
--> 
<template>
	<div class="fee-pay">
		<van-nav-bar left-text="返回"
			:title="$route.meta.title"
			@click-left="$comm.onClickLeft"
			left-arrow
			v-show="$comm.titleShow()"
			fixed>
			<template #left>
				<span class="iconfont iconshang comm-rotate-270"></span>
				<span class="comm-return">返回</span>
			</template>
		</van-nav-bar>
		<div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
		<div class="progress-info">
			<div class="info-top-wrapper"
				v-for="record in lists"
				:key="record.bussno">
				<div class="info-top">
					<div class="info-name">受理编号</div>：
					<div class="info-value">{{record.bussno}}</div>
				</div>
				<div class="info-top">
					<div class="info-name">抄表日期</div>：
					<div class="info-value">{{record.adddate}}</div>
				</div>
				<div class="info-top">
					<div class="info-name">用户号</div>：
					<div class="info-value">{{record.userno}}</div>
				</div>
				<div class="info-top">
					<div class="info-name">抄见度数</div>：
					<div class="info-value">{{record.cjs}} 立方米</div>
				</div>
				<div class="info-top">
					<div class="info-name">联系人</div>：
					<div class="info-value">{{record.uname}}</div>
				</div>
				<div class="info-top">
					<div class="info-name">联系电话</div>：
					<div class="info-value">{{record.tel}}</div>
				</div>
				<div class="info-top">
					<div class="info-name">状态</div>：
					<div class="info-value">{{record.status}}</div>
				</div>
				<div class="info-top">
					<div class="info-name">照片</div>：
					<div class="info-value">
						<van-button type="info"
							size="mini"
							@click="toShowImg(record)">查看</van-button>
					</div>
				</div>
			</div>
		</div>
		<van-image-preview v-model="showImg"
			:images="imgList"
			@change="onChange">
			<template v-slot:index>第{{ index }}页</template>
		</van-image-preview>
		<div style="height:17px;"></div>
		<div class="comm-homebar-height"></div>
		<home-bar></home-bar>
	</div>
</template>

<script>
import HomeBar from "@/components/HomeBar.vue";
export default {
	name: "readrecords",
	components: {
		HomeBar
	},
	data() {
		return {
			lists: [],
			imgList: [],
			index: 1,
			showImg: false
		};
	},
	mounted() {
		this.$http.post(this.$api.getRead, {}).then(res => {
			this.lists = res.data;
		});
	},
	methods: {
		onChange(index) {
			this.index = index + 1;
		},
		toShowImg(re) {
			this.showImg = true;
			this.imgList = re.attach.map(e => e.url);
		}
	}
};
</script>

<style lang="less" scoped>
.fee-pay {
	background: #ffffff;
	.progress-info {
		margin-top: 17px;
		.info-top-wrapper {
			background: rgba(240, 246, 241, 1);
			border-top: 1px solid rgba(214, 216, 214, 1);
			border-bottom: 1px solid rgba(214, 216, 214, 1);
			padding: 10px 6px;
			overflow: auto;
			margin-bottom: 10px;
			zoom: 1;
			.info-top {
				display: flex;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				float: left;
				width: 50%;
				color: rgba(33, 33, 33, 1);
				line-height: 30px;
				.info-name {
					width: 52px;
					text-align: justify;
					text-align-last: justify;
				}
				.info-value {
					width: calc(~"100% - 52px");
				}
			}
		}
		.info-bottom-wrapper {
			margin-top: 14px;
			background: rgba(240, 246, 241, 1);
			border-radius: 3px;
			.bottom-title {
				height: 26px;
				line-height: 26px;
				padding: 0 16px;
				background: rgba(240, 246, 241, 1);
				border: 1px solid rgba(214, 216, 214, 1);
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 33, 33, 1);
			}
			.bottom-info {
				display: flex;
				align-items: center;
				padding: 0 16px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 33, 33, 1);
				height: 35px;
				background: #ffffff;
				border-bottom: 1px solid rgba(214, 216, 214, 1);
				border-left: 1px solid rgba(214, 216, 214, 1);
				border-right: 1px solid rgba(214, 216, 214, 1);
				.bottom-name {
					width: 84px;
				}
				.bottom-value {
					width: calc(~"100% - 84px");
					text-align: right;
				}
			}
		}
		.code {
			margin-top: 30px;
			text-align: center;
			.code-img {
				img {
					width: 168px;
					height: 168px;
				}
			}
			.code-txt {
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(117, 117, 117, 1);
			}
		}
	}
}
</style>